// src/components/DisplayQuote.js

import QuoteData from './QuoteData';
import '../App.css';

function QuoteButton() {
  return (
    <div>
      <QuoteData />
    </div>
  );
}

export default QuoteButton;
